<template>
  <v-menu offset-y
      v-model="menu"
      ref="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      min-width="auto">

    <template v-slot:activator="{ on, attrs }">
      <v-row style="align-items: center;">
        <v-col cols="12" md="12" sm="12"> 
          <div class="input-helper">
            <div class="element"> 
              <v-text-field readonly 
                :tabindex="$attrs.tabindex"
                v-bind="attrs"
                v-model="output"
                v-on="on"
                :hint="hint"
                persistent-hint
                @input="_input"
                :prepend-icon="useIcon ? 'mdi-calendar' : ''"
                :label="cmpLabel"
                :rules="rules">

                <template v-slot:message="{ message }">
                    <span v-html="message"></span>
                </template>

                <template slot="append">
                  <v-btn x-small fab class="cleanBtn"
                    elevation="0"
                    tabindex="-1"
                    v-if="output != null && output != ''" 
                    @click="output = ''; _input('')">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-text-field>
            </div>
            <div class="flex-btn"> 
              <v-btn x-small fab class="helperBtn" v-if="!!helperText" 
                elevation="0"
                tabindex="-1"
                @click="_showHelperText">
                <v-icon>mdi-help</v-icon>
              </v-btn>
            </div>  
          </div>
        </v-col>
      </v-row>

      <HelperDialog
        :helperText="helperText"
        :show="helperTextPopUpVisible"
        @close="_closeHelperText">
      </HelperDialog>      

    </template>

    <v-date-picker 
      v-model="output"
      @input="_input"
      @change="_save"
      :active-picker.sync="activePicker"
      :max="max"
      :min="min">
    </v-date-picker>

  </v-menu>
</template>

<script>

  import HelperDialog from "./helper-dialog.vue"
  import generic from '@/shared/utils/generic.js';

  export default {
    name: 'PersonalDetails',
    inheritAttrs: false,
    components: { 
      HelperDialog
    },
    props: {
      min: { type: String },
      max: { type: String },
      startUpValue: { type: String },
      label: { type: String },
      useIcon: { type: Boolean },
      hint: { type: String },
      rules: { type: Array },
      helperText: { type: String },
      birthdayMode: { type: Boolean },
    },
    emits: ["input"],
    data: () => ({
      menu: false,
      output: '',
      helperTextPopUpVisible: false,
      activePicker: null,
      isRequired: undefined,
    }),
    watch: {
      menu (val) {
        this.birthdayMode && val && setTimeout(() => { this.activePicker = 'YEAR'; });
      },
    },    
    created() {
      this.output = this.startUpValue;
      this.isRequired = generic.isRequired(this.rules);
    },
    methods: {
      _showHelperText () { 
        if (this.helperText) this.helperTextPopUpVisible = true;  
      },

      _closeHelperText() { 
        this.helperTextPopUpVisible = false;  
      },

      _input(value) {
        this.$emit("input", value); 
      },

      _save (date) {
        this.$refs.menu.save(date);
      },
    },
    computed: {
      cmpLabel: {
        get() { return this.label + (this.isRequired ? ' *' : ''); },
      }      
    }
  };
</script>
